// copied from @confluence/graphql/src/links/AGGWebSocketLink/getWebSocketURL.ts. Once we move to Relay, we can remove the file from that package.

export function getWebSocketURL(): string {
	let WEBSOCKET_URL: string;

	if (process.env.NODE_ENV !== 'production') {
		// In dev mode this allows the local dev proxy to use the WebSocket host
		// that matches the backend origin host. The __backendOriginHost is only
		// available with local dev server.
		const host = (window as any)?.__backendOriginHost || window?.location?.host;

		WEBSOCKET_URL = `wss://${host}/gateway/api/graphql/subscriptions`;
	} else {
		WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
	}

	return WEBSOCKET_URL;
}
